module.exports = __webpack_public_path__ + "media/assets/images/tour/4b_Tour_4-ed26cecab60e761d4faa2d2023ad6dc0.png";